/* eslint-disable no-restricted-globals */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';
import Grid from '@material-ui/core/Grid';
import { Button, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Autocomplete } from '@material-ui/lab';
import { DateTime } from 'luxon';
import adm from '../../service/adm';
import Filter from '../../components/Filter';
import { Header, Container } from '../../styles/shared/styles';


const M3tasResources = () => {
    const [filters, setFilters] = useState({
        initDate: DateTime.now().toISODate(),
        endDate: DateTime.now().toISODate(),
        lead: null,
        cleanLeadOption: null,
        client: null,
        channels: null,
        status: null,
        cleanMaisTodosOption: null,
    });
    const cleanLeadOptionsList = [{ id: 1, name: 'Soft Delete' }, { id: 2, name: 'Apagar' }];

    const handleFilter = () => {

    }

    const handleClear = () => {
        setFilters({
            initDate: DateTime.now().toISODate(),
            endDate: DateTime.now().toISODate(),
            lead: null,
            cleanLeadOption: null,
            client: null,
            channels: null,
            status: null,
            cleanMaisTodosOption: null,
        });
    };

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleClearAllLeads = async () => {
        if (!confirm('Tem certeza que deseja apagar TODOS os leads? Esta ação é irreversível!'))
            return;
        if (filters.cleanMaisTodosOption)
            if (!confirm('Confirma que vai apagar todas as transações da MaisTODOS? Esta ação é irreversível!'))
                return;

        try {
            const response = await adm.post(`/deleteAllLeads`, {
                initDate: filters.initDate,
                endDate: filters.endDate,
                lead: filters.lead,
                cleanLeadOption: filters.cleanLeadOption?.id,
                cleanMaisTodosOption: filters.cleanMaisTodosOption,
            });

            if (response.status == 200) {
                alert('Limpeza dos Leads realizada!');
                toast.warning(response.data);
            }
        }
        catch (error) {
            alert(error.errorInfo);
            toast.error(error);
        }
    }

    const handleClearLeads = async () => {
        if (!confirm('Tem certeza que deseja apagar os leads filtrados? Esta ação é irreversível!'))
            return;

        try {
            const response = await adm.post(`/deleteLeads`, {
                initDate: filters.initDate,
                endDate: filters.endDate,
                lead: filters.lead,
                cleanLeadOption: filters.cleanLeadOption?.id,
                channels: filters.channels,
                status: filters.status,
            });

            if (response.status == 200) {
                alert('Limpeza dos Leads realizada!');
                toast.warning(response.data);
            }
        }
        catch (error) {
            alert(error.errorInfo);
            toast.error(error);
        }
    }

    const handleClearAllClients = async () => {
        if (!confirm('Tem certeza que deseja apagar TODOS os clientes? Esta ação é irreversível!'))
            return;

        try {
            const response = await adm.post(`/deleteAllClients`, {
                initDate: filters.initDate,
                endDate: filters.endDate,
                client: filters.client,
            });

            if (response.status == 200) {
                alert('Limpeza dos clientes realizada!');
                toast.warning(response.data);
            }
        }
        catch (error) {
            alert(error.errorInfo);
            toast.error(error);
        }
    }

    const handleClearUsers = async () => {
        if (!confirm('Tem certeza que deseja apagar os usuários? Esta ação é irreversível!'))
            return;

        try {
            const response = await adm.post(`/deleteUsers`, { });

            if (response.status == 200) {
                alert('Limpeza dos usuários realizada!');
                toast.warning(response.data);
            }
        }
        catch (error) {
            alert(error.errorInfo);
            toast.error(error);
        }
    }


    return (
        <>
            <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
                <Container>
                    <Header>
                        <h1>Recursos M3tas</h1>
                    </Header>

                    <Filter
                        buttonStyle={{ "height": "fit-content" }}
                        clickFilter={handleFilter}
                        clearFilter={handleClear}
                    >
                        <Grid container spacing={2}>
                            <label>
                                Client Id
                                <input
                                    type="number"
                                    name="client"
                                    className="input-form"
                                    title='Cliente'
                                    value={filters.client}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Lead
                                <input
                                    type="number"
                                    name="lead"
                                    className="input-form"
                                    title='Lead'
                                    value={filters.lead}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Canais de Origem
                                <input
                                    type="text"
                                    name="channels"
                                    className="input-form"
                                    placeholder='1,2,3,...'
                                    value={filters.channels}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Etapa
                                <input
                                    type="number"
                                    name="status"
                                    className="input-form"
                                    value={filters.status}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Data início:
                                <input
                                    type="date"
                                    name="initDate"
                                    className="input-form"
                                    title='De'
                                    value={filters.initDate}
                                    onChange={handleChange}
                                />
                            </label>

                            <label>
                                Data fim:
                                <input
                                    type="date"
                                    name="endDate"
                                    className="input-form"
                                    title='Até'
                                    value={filters.endDate}
                                    onChange={handleChange}
                                />
                            </label>

                        </Grid>
                    </Filter>

                    <br />
                    <Divider />
                    <br />

                    <div>
                        <Autocomplete
                            xs={4}
                            disableClearable
                            options={cleanLeadOptionsList || [1]}
                            getOptionLabel={(option) => option?.name || [1]}
                            value={filters.cleanLeadOption || [1]}
                            onChange={(e, value) => setFilters({ ...filters, cleanLeadOption: value })}
                            renderInput={(params) => (
                                <TextField {...params}
                                    className="autocomplete"
                                    variant="standard"
                                    label="Opções"
                                />
                            )}
                            style={{
                                width: '200px'
                            }}
                        />
                        <FormControlLabel
                            label="Remover MaisTodos"
                            control={
                                <Checkbox
                                    color="default"
                                    checked={filters.cleanMaisTodosOption}
                                    onChange={(e) => setFilters({ ...filters, cleanMaisTodosOption: e.target.checked })}
                                />
                            }
                        />
                        <br />
                        <Button
                            disabled={!filters.cleanLeadOption}
                            variant="contained"
                            onClick={handleClearLeads}>
                            Limpar Leads Específicos
                        </Button>

                        <Button
                            disabled={!filters.cleanLeadOption}
                            variant="contained"
                            onClick={handleClearAllLeads}>
                            Limpar Todos Leads
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleClearAllClients}>
                            Limpar Todos Clientes
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleClearUsers}>
                            Limpar Usuários
                        </Button>
                    </div>

                    <br />
                    <Divider />
                    <br />

                    <Link to='/companies-group'>
                        Grupo de Empresas
                    </Link>

                </Container>
            </motion.div>
        </>
    );
};


export default M3tasResources;
